import React from 'react'
import { Alert } from 'react-bootstrap'

const index = ({message,onClick,varian}) => {
  return (
    <Alert variant={varian} onClose={onClick} dismissible style={{ borderRadius:12}}>
      <span>
        {message}
      </span>
    </Alert>
  )
}

export default index
